export const START = '_START'
export const SUCCESS = '_SUCCESS'
export const ERROR = '_ERROR'
export const STOP = '_STOP'

// ** header
export const HEADER_FETCH_DATA = 'HEADER_FETCH_DATA'

//** Settings
export const SETTINGS_INTEGER_DATA_CHANGED = 'SETTINGS_INTEGER_DATA_CHANGED'
export const SETTINGS_STRING_DATA_CHANGED = 'SETTINGS_STRING_DATA_CHANGED'
export const SETTINGS_BOOLEAN_DATA_CHANGED = 'SETTINGS_BOOLEAN_DATA_CHANGED'
export const SETTINGS_SET_SETTINGS = 'SETTINGS_SET_SETTINGS'
export const SETTINGS_GET_OPTIONS = 'SETTINGS_GET_OPTIONS'
export const SETTINGS_GET_SETTINGS = 'SETTINGS_GET_SETTINGS'
export const SETTINGS_SAVE_SETTINGS = 'SETTINGS_SAVE_SETTINGS'
export const SETTINGS_SET_SETTINGS_STATE = 'SETTINGS_SET_SETTINGS_STATE'

//** Locales
export const LOCALIZATION_GET_STRINGS = 'LOCALIZATION_GET_STRINGS'

//** Editor
export const EDITOR_GET_DATA = 'EDITOR_GET_DATA'
export const EDITOR_POST_DATA = 'EDITOR_POST_DATA'
export const EDITOR_CHANGE_DATA = 'EDITOR_CHANGE_DATA'
export const EDITOR_SET_STYLE = 'EDITOR_SET_STYLE'
export const EDITOR_SET_BODY = 'EDITOR_SET_BODY'
export const EDITOR_SET_CAPTION = 'EDITOR_SET_CAPTION'
export const EDITOR_SET_BORDER = 'EDITOR_SET_BORDER'
export const EDITOR_SET_IMAGE = 'EDITOR_SET_IMAGE'

//** Styles
export const STYLES_FETCH_DATA = 'STYLES_FETCH_DATA'
export const STYLES_SET_TRASH = 'STYLES_SET_TRASH'
export const STYLES_NEED_RELOAD = 'STYLES_NEED_RELOAD'

export const STYLES_CHANGE_FILTER = 'STYLES_CHANGE_FILTER'

//** Themes
export const THEMES_LOADING_THEMES_INFO = 'THEMES_LOADING_THEMES_INFO'
export const THEMES_ACTIVATE_THEME = 'THEMES_ACTIVATE_THEME'
